// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__jNqDc","check":"Checkbox_check__iERpX"};